// Contact attributes, stored directly in the contact, not customMetadata
export const STANDARD_CONTACT_PROPERTY_KEYS = [
  'firstName',
  'lastName',
  'email',
  'phone',
  'title',
  'timezone',
];

// Contact attributes, stored directly in the company, not customMetadata
export const STANDARD_COMPANY_PROPERTY_KEYS = [
  'name',
  'description',
  'domain',
  'revenue',
  'industry',
  'targetAccount',
  'sizeEstimateLow',
  'sizeEstimateHigh',
  'location',
  'country',
];
